<template>
  <common-dialog
    @opened="onOpened"
    ref="dialog"
    :title="title"
    width="1300px"
    :in-dialog="inDialog"
  >
    <list ref="list"> </list>

    <template slot="footer">
      <el-button type="primary" size="small" @click="submitmul">提交</el-button>
    </template>
  </common-dialog>
</template>
  <script>
import commonDialog from "@/components/common/dialog";
import list from "./inlist";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "商品列表",
    },
    showstatus: {
      type: Boolean,
      default: true,
    },
    sameBusiness: {
      type: Boolean,
      default: false,
    },
    pickChild: {
      type: Boolean,
      default: false,
    },
    isMallGoods: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {
        GoodsName: "", //名称
        BrandId: null, //品牌

        State: null, //状态 - 0：停用，1：正常
        SaleState: 1, //上下架状态 - 0：下架，1：上架
        TradeMode: null,
        FilingsOrderids: "", //对应的保税商品备案序号
        FilingsNames: "", //对应的保税商品备案名称
        IsMonth: null,
        IsNewStyle: null,
      },
      ChooseIds: [],
      ChooseData: [],
      checkRow: [],
      ChooseModelIds: [],
      ChooseModelData: [],
      Brands: [],
      api: require("@/api/goods/info").default,
      TypePlatforms: [],
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      brand_api: require("@/api/goods/brand").default,
      typeplatform_api: require("@/api/goods/typeplatform").default,

      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.brand_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    });
    this.typeplatform_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
  },
  methods: {
    onResetQuery() {
      console.log("onResetQuery", this.params);
      if (this.$refs.picker1) this.$refs.picker1.clear();
      if (this.$refs.picker2) this.$refs.picker2.clear();
    },
    onTbSelect(selection, row) {
      console.log("ontbselect");
      if (this.checkRow.length > 0) {
        this.checkRow.forEach((e, index) => {
          if (row.RecordId == e.RecordId) {
            this.checkRow.splice(index, 1);
            return;
          }
          if (index == this.checkRow.length - 1) {
            this.checkRow.push(row);
          }
        });
      } else {
        this.checkRow.push(row);
      }
    },
    selectAll(selection, recordId) {
      if (selection.length > 0) {
        selection.forEach((n) => {
          var has = false;
          this.checkRow.forEach((e) => {
            if (n.RecordId == e.RecordId) {
              has = true;
            }
          });
          if (!has) {
            this.checkRow.push(n);
          }
        });
      } else {
        for (let i = 0; i < this.checkRow.length; i++) {
          var e = this.checkRow[i];
          if (e.RecordId == orderId) {
            this.checkRow.splice(i, 1);
            i--;
          }
        }
      }
    },
    expandChange(row, t) {
      var has = false;
      t.forEach((e) => {
        if (e.RecordId == row.RecordId) {
          has = true;
          return;
        }
      });
      if (!has) {
        return;
      }
      this.checkRow.forEach((e) => {
        if (e.RecordId == row.RecordId) {
          this.$nextTick(() => {
            this.$refs["prod" + row.RecordId].toggleRowSelection(e, true);
          });
        }
      });
    },
    onOpened(data) {
      this.ChooseIds = [];
      this.ChooseData = [];
      this.checkRow = [];
      this.ChooseModelData = [];
      this.ChooseModelIds = [];
      // this.$refs.list.params.OrderStatus = this.custype
      // this.query();
    },
    selectItem(row) {
      this.ChooseIds.push(row.RecordId);
      this.ChooseData.push(row);
      console.log("this.ChooseData", this.ChooseData);

      this.ChooseData.map((item) => {
        if (row.RecordId == item.RecordId) {
          row.OrderGoods.forEach((item) => {
            item.Quantity = item.MainunitCount - (item.SendCount || 0);
          });
        }
      });
    },
    chanelItem(row, index) {
      this.ChooseData.splice(index, 1);
      this.ChooseIds.splice(index, 1);
      this.ChooseModelData.forEach((e, index) => {
        if (e.OrdermainId == row.RecordId) {
          this.ChooseModelData.splice(index, 1);
        }
      });
      this.ChooseModelIds = this.ChooseModelData.map((item) => item.RecordId);
    },
    selectItem2(row) {
      this.ChooseModelIds.push(row.RecordId);
      this.ChooseModelData.push(row);
      console.log("this.ChooseModelData", this.ChooseModelData);
    },
    chanelItem2(row, index) {
      console.log("chanelItem2", row);
      this.ChooseModelIds.forEach((e, index) => {
        if (e == row.RecordId) {
          this.ChooseModelIds.splice(index, 1);
        }
      });
      this.ChooseModelData.forEach((e, index) => {
        if (e.RecordId == row.RecordId) {
          this.ChooseModelData.splice(index, 1);
        }
      });
      if (this.ChooseData.length > 0) {
        this.ChooseData.forEach((e, index) => {
          if (e.RecordId == row.OrdermainId) {
            var length = this.ChooseModelData.filter(
              (x) => x.OrdermainId == e.RecordId
            ).length;

            if (length < 1) {
              this.ChooseData.splice(index, 1);
            }
          }
        });
        this.ChooseIds = this.ChooseData.map((item) => item.RecordId);
      }
    },
    submitmul() {
      var issumit = true;
      let rows = this.$refs.list.getCheckedRows();
      console.log(rows, "row");
      if (rows.length == 0) {
        this.$message.warning("请选择入库商品");
        return;
      }
      var arr2 = { OrderGoods: [] };
      rows.forEach((item) => {
        item.Attributes.forEach((x) => {
          if (x.checked) {
            var checkModel = arr2.OrderGoods.find(
              (w) => w.AttributeId == x.RecordId
            );
            if (!checkModel)
              arr2.OrderGoods.push({
                RecordId: 0,
                IndocId: 0,
                OrderId: 0, //序号
                GoodsId: x.GoodsId, //商品
                GoodsCode: x.GoodsCode, //商品编码
                GoodsName: x.GoodsName, //商品名称
                TypeName: x.TypeName, //商品分类
                GoodsModel: "", //规格型号
                MainUnitName: x.MainUnitName, //单位
                AttributeId: x.RecordId, //属性
                AttributeName: x.AttributeName, //属性名称
                AttributeCode: x.AttributeCode, //属性名称编码
                InCount: null, //入库数量
                InPrice: null, //入库单价
                InAmount: null, //入库金额
                T: 0,
              });
          }
        });
      });
      this.onSelect(arr2);

      // if (this.ChooseData.length > 0) {
      //   if (this.ChooseModelData.length < 1) {
      //     this.$message.error("请选择发货商品");
      //     return false;
      //   }
      //   if (this.sameBusiness) {
      //     //限制同个客户
      //     var personId = this.ChooseData[0].PersonId;
      //     this.ChooseData.forEach((e) => {
      //       if (e.PersonId != personId) {
      //         issumit = false;
      //         this.$message.warning("需要选择同个用户");
      //       }
      //     });
      //   }
      //   if (issumit) {
      //     // var list = []
      //     //  this.ChooseData.map((x,i) =>{
      //     //   x.detailData.map((item,index)=>{
      //     //     this.checkRow.map((k,j) =>{
      //     //       if(k.OrderDetailId == item.OrderDetailId){
      //     //         list.splice(index,1)
      //     //       }else{
      //     //         list.push(row[0])
      //     //       }
      //     //     })
      //     //   })
      //     // })
      //     // this.onSelect(this.checkRow);

      //     // this.checkRow.forEach((e) => {
      //     //   arr.forEach((n) => {
      //     //     if (n.OrderId == e.OrderId) {
      //     //       n.OrderDetail.push(e);
      //     //     }
      //     //   });
      //     // });
      //     this.ChooseModelData.forEach((item) => {
      //       var ordermain = this.ChooseData.find(
      //         (x) => x.RecordId == item.OrdermainId
      //       );
      //       if (ordermain) {
      //         item.OrderNo = ordermain.OrderNo;
      //         item.OrderDate = ordermain.OrderDate;
      //       }
      //     });
      //     var arr2 = {
      //       StoreId: this.ChooseData[0].StoreId,
      //       ReceivingPerson: this.ChooseData[0].ReceivingPerson,
      //       ReceivingAddress: this.ChooseData[0].ReceivingAddress,
      //       ReceivingPhone: this.ChooseData[0].ReceivingPhone,
      //       OrderGoods: this.ChooseModelData,
      //     };
      //     // console.log(arr2)
      //     // return;
      //     this.ChooseData = [];
      //     this.ChooseIds = [];
      //     this.checkRow = [];
      //     this.ChooseModelIds = [];
      //     this.ChooseModelData = [];
      //     console.log("arr2", arr2);
      //     this.onSelect(arr2);
      //     // this.onSelect(this.ChooseData);
      //   }
      // } else {
      //   this.$message.warning("请选择订单");
      // }
    },
    summaryCount(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.label == "总长度") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(((prev * 1000 + curr * 1000) / 1000).toFixed(4));
            } else {
              return Number(prev - 0).toFixed(4);
            }
          }, 0);
        } else if (column.label == "主单位数量") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
        } else if (column.label == "辅助单位数量") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "-";
        }
      });
      return sums;
    },
  },
};
</script>
  <style lang="scss" scoped>
.choosetable {
  margin: 10px;
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
  /deep/ .el-card__header {
    padding: 10px 20px;
  }
}
</style>
  